// Generated by purs version 0.15.15
import * as Control_Category from "../Control.Category/index.js";
import * as Ouroboros_Models_Ui_VisibilityPhase from "../Ouroboros.Models.Ui.VisibilityPhase/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_Controllers_PasswordResetRequest from "../Ouroboros.Programs.Controllers.PasswordResetRequest/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
var visibilityPhaseFromOption = /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
    return Ouroboros_Models_Ui_VisibilityPhase.visibilityPhaseNamespace.hidden;
})(function (v) {
    return Ouroboros_Models_Ui_VisibilityPhase.visibilityPhaseNamespace.visible;
});
var visibilityPhaseFromBoolean = function (value) {
    if (value) {
        return Ouroboros_Models_Ui_VisibilityPhase.visibilityPhaseNamespace.visible;
    };
    return Ouroboros_Models_Ui_VisibilityPhase.visibilityPhaseNamespace.hidden;
};
var readState = function (v) {
    return v;
};
var optionToString = /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
    return "";
})(/* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn));
var buildPasswordResetRequestViewProps = function (input) {
    return {
        email: readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.email)),
        onEmailChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(input.kernel.email))(value);
        },
        onSubmit: function (v) {
            return Ouroboros_Programs_Controllers_PasswordResetRequest.runPasswordResetRequestAction(input.kernel.controller.submit);
        },
        onNavigateToLogin: function (v) {
            return Ouroboros_Programs_Controllers_PasswordResetRequest.runPasswordResetRequestAction(input.kernel.controller.navigateToLogin);
        },
        logoPhase: visibilityPhaseFromOption(input.logoUri),
        logoUri: optionToString(input.logoUri),
        noticePhase: visibilityPhaseFromBoolean(readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.submitted)))
    };
};
export {
    buildPasswordResetRequestViewProps
};
//# sourceMappingURL=index.js.map
